var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      attrs: {
        flat: _vm.flat,
        "min-height": !_vm.renderUrl ? 200 : "calc(100vh - 600px)",
      },
    },
    [
      _vm.showToolbar
        ? [
            _c(
              "v-toolbar",
              { staticClass: "transparent", attrs: { flat: "", height: "46" } },
              [
                _c(
                  "v-toolbar-title",
                  {
                    staticClass:
                      "px-5 subtitle-2 grey-700--text font-weight-semibold",
                  },
                  [
                    _vm._v(
                      "PDF " +
                        _vm._s(_vm.documentType) +
                        " Nº " +
                        _vm._s(_vm.number)
                    ),
                  ]
                ),
                _c("v-spacer"),
                _vm.showTemplateSelector && _vm.templates.length > 0
                  ? [
                      _c(
                        "span",
                        {
                          staticClass:
                            "subtitle-2 font-weight-medium grey-500--text mr-3",
                        },
                        [_vm._v("Elija plantilla")]
                      ),
                      _c("v-select", {
                        staticClass: "mr-2",
                        staticStyle: { "max-width": "200px" },
                        attrs: {
                          value: _vm.selectedTemplate,
                          items: _vm.templates,
                          "item-text": "name",
                          "return-object": "",
                          "menu-props": {
                            overflowY: true,
                            transition: "slide-y-transition",
                            offsetY: true,
                            bottom: true,
                          },
                          height: "30",
                          "single-line": "",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          "append-icon": "mdi-chevron-down",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$emit("update:selectedTemplate", $event)
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prepend-inner",
                              fn: function () {
                                return [
                                  _c("img", {
                                    staticClass: "mr-1 py-1",
                                    attrs: {
                                      src: require(`@/assets/account/account-choose-icon${
                                        _vm.$vuetify.theme.dark ? "-dark" : ""
                                      }.svg`),
                                      width: 16,
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-inline-block text-truncate",
                                      staticStyle: { "max-width": "130px" },
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          952682163
                        ),
                      }),
                    ]
                  : _vm._e(),
                _c(
                  "v-toolbar-items",
                  [
                    _c(
                      "v-row",
                      {
                        staticClass: "mr-4",
                        attrs: { align: "center", justify: "center" },
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              "retain-focus-on-click": "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("close")
                              },
                            },
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "grey-500", size: "20" } },
                              [_vm._v("mdi-close")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _c("v-divider"),
          ]
        : _vm._e(),
      _c(
        "v-card-text",
        { staticClass: "pa-0 overflow-hidden" },
        [
          _vm.alert && !_vm.loaderRender && _vm.renderUrl
            ? _c(
                "v-alert",
                {
                  staticClass: "body-2 py-3 mb-0",
                  attrs: { dense: "", tile: "", color: "grey-500", dark: "" },
                },
                [_vm._v(_vm._s(_vm.alert))]
              )
            : _vm._e(),
          _vm.loaderRender
            ? _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "px-4 py-0 ma-0", attrs: { cols: "12" } },
                    [_c("VSkeleton")],
                    1
                  ),
                ],
                1
              )
            : !_vm.renderUrl
            ? _c("v-empty-state", {
                staticClass: "py-14",
                attrs: {
                  title: "PDF no disponible",
                  height: 100,
                  type: "pdf",
                  customClass: "mt-6",
                  isFree: true,
                },
              })
            : _vm._e(),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loaderRender && _vm.renderUrl && !_vm.basicRender,
                expression: "!loaderRender && renderUrl && !basicRender",
              },
            ],
            attrs: { id: "render" },
          }),
          _c("object", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loaderRender && _vm.renderUrl && _vm.basicRender,
                expression: "!loaderRender && renderUrl && basicRender",
              },
            ],
            key: _vm.renderUrl,
            attrs: {
              data: _vm.renderUrl,
              type: "application/pdf",
              width: "100%",
              height: _vm.$vuetify.breakpoint.height <= 700 ? 450 : 600,
            },
          }),
        ],
        1
      ),
      _vm.showFooter && !_vm.loaderRender && _vm.renderUrl
        ? [
            _c("v-divider"),
            _c(
              "v-card-actions",
              { staticClass: "px-5 py-2" },
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      href: _vm.renderUrl,
                      download: _vm.name,
                      color: "grey-900",
                      dark: "",
                    },
                  },
                  [_vm._v("Descargar PDF")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }